import React, { useCallback, useState } from "react";
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import "react-phone-input-2/lib/style.css";
import useDebounce from "./useDebounce";
import config from "../config/index"; 

const customAxiosInstance = axios.create({
    validateStatus(status) { 
        // return true means:
        // don't reject promise if status is outside 2xx
        return true;
    },
});

const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: '#9e9e9e',
      minHeight: '30px',
      height: '30px',
      boxShadow: state.isFocused ? null : null,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: '30px',
      padding: '0 6px'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '30px',
    }),
    menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
    container: (provided) => ({
    ...provided,
    boxSizing: "border-box",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "12px",
  }),
  };

function SelectInputAutocomplete({ value, setValue, size="sm", disabled=false, body }) {
  const onChange = value => {
     setValue(value);
   };

  const loadData = async (inputValue) => {
    const data = await customAxiosInstance.post(`${config.api.baseUrl}/wellness/clientes`,
      body,
    {
      headers: {
        'x-access-token': config.api.key,
      },
        params: {
        nombre: inputValue,
      }
    });

    if(data.data[0].value === "error") {
      alert(data.data[0].label);
    }
    
    return data.data;
  } 
  
  const loadDataDebounced = useCallback(
    useDebounce((inputValue, callback) => {
        loadData(inputValue).then(options => callback(options))
    }, 500),
    []);

  return (
    <label>
    Buscador de cliente 
    <AsyncSelect
      value={value}
      loadOptions={loadDataDebounced}
      onChange={onChange}
      size={size}
      disabled={disabled}
      placeholder="Introduzca nombre o CI/RUC del cliente"
      menuPortalTarget={document.body} 
      styles={customStyles}
      />
    </label>
  );
}

export default SelectInputAutocomplete;
